__turbopack_context__.v({
  "profile-photo-container": "profile-photo-with-badge-module-scss-module__keLh4G__profile-photo-container",
  "profile-photo-container__badge": "profile-photo-with-badge-module-scss-module__keLh4G__profile-photo-container__badge",
  "profile-photo-container__button": "profile-photo-with-badge-module-scss-module__keLh4G__profile-photo-container__button",
});
